import { useEffect, useMemo, useState } from 'react';
import getBlurHashComponents from '_utils/getBlurHashComponents';

interface ImageDimensions {
    width: number;
    height: number;
}

const useImageAspectRatio = (blurhash: string | null) => {
    const { aspect_ratio: aspectRatioFromBlurHash } = useMemo(() => getBlurHashComponents(blurhash ?? ''), [blurhash]);
    const [aspectRatio, setAspectRatio] = useState<number | null>(aspectRatioFromBlurHash ?? null);

    useEffect(() => {
        if (aspectRatioFromBlurHash) {
            setAspectRatio(aspectRatioFromBlurHash);
        }
    }, [aspectRatioFromBlurHash]);

    const handleLoad = ({ width, height }: ImageDimensions) => {
        const ratio = width / height;
        setAspectRatio(ratio);
    };

    return {
        aspectRatio,
        handleLoad,
    };
};

export default useImageAspectRatio;
